export const GET_PRODUCT_REQUEST = "GET_PRODUCT_REQUEST";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAILURE = "GET_PRODUCT_FAILURE";

export const POST_PRODCUT_REQUEST = "POST_PRODUCT_REQUEST"
export const POST_PRODCUT_SUCCESS = "POST_PRODUCT_SUCCESS"
export const POST_PRODCUT_FAILURE = "POST_PRODUCT_FAILURE"


export const GET_PRODCUT_REQUEST = "GET_PRODUCT_REQUEST"
export const GET_PRODCUT_SUCCESS = "GET_PRODUCT_SUCCESS"
export const GET_PRODCUT_FAILURE = "GET_PRODUCT_FAILURE"



export const DELETE_FROM_CART_REQUEST='delete/cart/request';
export const DELETE_FROM_CART_SUCCESS='delete/cart/success';
export const DELETE_FROM_CART_FAILURE='delete/cart/failure';